export default {
  title_top: 'お問い合わせ',
  title_bottom: 'お問い合わせいただき、ありがとうございます。',
  desc: 'お問い合わせいただきました内容はご確認として、ご記入いただきましたメールアドレス宛に自動送信メールをお送りしています。\n\n'
      + '近日中に弊社担当者からご連絡差し上げますので、しばらくお待ちください。\tお急ぎの場合や数日を過ぎても連絡がない場合は、お手数ですがお電話にてお問い合わせください。',
};
